import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[toggleDropdown]'
})
export class ToggleDropdownDirective {
  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();

    if (window.innerWidth <= 991) {
      const { className } = event.target.parentElement.parentElement;
      const splitClassName = className.split(' ');
      const dropdownIsActive =
        splitClassName.find(i => i === 'active') || false;
      const newClassName = splitClassName.reduce((accum, obj) => {
        const name = obj !== 'active' ? obj : '';
        return `${accum} ${name}`;
      }, '');
      event.srcElement.parentElement.parentElement.className = dropdownIsActive
        ? newClassName
        : `${className} active`;
    }
  }
}
